import { useState, useRef } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';
import { useTheme } from '../../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';
import { useLanguage } from '../../../../../Context/LanguageContext';

// Model //
import FetchModule from '../../../../Share/Network/FetchModule.js';
// Model //

// Component //
import UserNameChangeInput from '../../../../../Component/MemberComponent/MemberDetail/UserNameChangeInput.js';
import PhoneChangeInput from '../../../../../Component/MemberComponent/MemberDetail/PhoneInput.js';
import CalenderInput from '../../../../../Component/MemberComponent/CalenderInput.js';
// Component //

// Image //
import DefaultProfile from '../../../../../image/DefaultProfile.png'
// Image //

export default function UserNameModifyModal(props) {
  const { profile, userName, birthDay, gender, phone, onClickClose, onClickSave } = props;
  const { t } = useLanguage();

  const [date, setDate] = useState(moment(birthDay).format('YYYY.MM.DD'));
  const [changedName, setChangedName] = useState(userName);
  const [changeGender, setChangeGender] = useState(gender);
  
  const [isCheckedPhone, setIsCheckedPhone] = useState(false);
  const [changePhone, setChangePhone] = useState(phone);

  const [imgBase64, setImgBase64] = useState(profile);
  const [imgFile, setImgFile] = useState('');
  const [isErrorProfile, setIsErrorProfile] = useState(false);

  const hiddenFileInput = useRef(null);

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;


  function onClickInput() {
    hiddenFileInput.current.click();
	}
	
  function onChangeInput(e) { 
    let pathpoint = e.target.value.lastIndexOf('.');
    let filepoint = e.target.value.substring(pathpoint + 1, e.target.length);
    let filetype = filepoint.toLowerCase();

    if (filetype === 'jpg' || filetype === 'png' || filetype === 'jpeg') {

      // 정상적인 이미지 확장자 파일인 경우

    } 
    else {
      alert(t('memberDetail.modifyModal.alertImageFormat'));
      let parentObj = e.target.parentNode
      let node = parentObj.replaceChild(e.target.cloneNode(true), e.target);

      return false;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
			const base64 = reader.result;
      
			if (base64){
				setImgBase64(base64.toString());
			}
		};

		if (e.target.files[0]) {
      reader.readAsDataURL(e.target.files[0]);
      setImgFile(e.target.files[0]);
		}
	}

  function onError() {
    setIsErrorProfile(true);
  }

  function decideUserProfile() {
    if (isErrorProfile) return DefaultProfile;
    else if (imgFile) return URL.createObjectURL(imgFile);
    else if (imgBase64 !== '') return imgBase64;
    else return DefaultProfile;
  }
  

  // 아무 동작 없음 //
  function clickFn() {}

  // 저장 버튼 클릭시 //
  function onClickSaveButton() {

    onClickSave(imgBase64, changedName, moment(date).format('YYYYMMDD'), changeGender, changePhone);
  }

  // 전화번호 확인 버튼 클릭시 //
  function onClickCheckButton() {

    if (changePhone === phone) return;
    else if (isCheckedPhone) return;
    
    if (changePhone.length < 9) {
      alert(t('memberDetail.modifyModal.alertPhoneInvalid'));
      return;
    }

    let data = {
      phone: changePhone,
      userId: '',
      profile: ''
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfCoach('userInfo/detail/invalid/user', 'POST', data);
        
        if (responseData.status === 200) {
          alert(t('memberDetail.modifyModal.alertPhoneVerified'));
          setChangePhone(responseData.data[0].phone);
          setIsCheckedPhone(true);
        }
        else if (responseData.status === 201) {
          alert(t('memberDetail.modifyModal.alertPhoneMismatch'));
        }
        else if (responseData.status === 204) {
          alert(t('memberDetail.modifyModal.alertPhoneNotFound'));
        }
      }
    )();
  }

  return (
    <TotalModalWrapper>
      <input type="file"
        ref={hiddenFileInput}
        onChange={onChangeInput}
        style={{ display: 'none' }} />
      <ModalView $isDark={isDark}>
        <TitleWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('memberDetail.modifyModal.modifyTitle')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.modifyModal.modifyDescription')}</Text>
        </TitleWrapper>
        <TotalWrapper>
          <ProfileBoxWrapper onClick={onClickInput}>
            {
              imgBase64 !== '' ?
                <Profile src={decideUserProfile()} onError={onError} />
                :
                <ProfileBox>
                  <PlusBox>
                    <Stick width={50} height={6} />
                    <Stick width={6} height={50} />
                  </PlusBox>
                </ProfileBox>
            }
          </ProfileBoxWrapper>
          <InfoBox>
          <InputWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.modifyModal.changeName')}</Text>
            <UserNameChangeInput value={changedName} setValue={setChangedName} placeholder={t('memberDetail.modifyModal.changeNamePlaceholder')}/>
          </InputWrapper>
          <InputWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.modifyModal.changePhone')}</Text>
            <PhoneChangeInput
              value={changePhone}
              setValue={setChangePhone}
              isCheckedPhone={isCheckedPhone}
              setIsCheckedPhone={setIsCheckedPhone}
              originalPhone={phone}
              placeholder={t('memberDetail.modifyModal.changePhonePlaceholder')}
              onClickCheck={onClickCheckButton}/>
          </InputWrapper>
          <DateInputWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{t('memberDetail.modifyModal.changeBirthDate')}</Text>
            <CalenderInput value={date} setValue={setDate} clickFn={clickFn} width={208}/>
          </DateInputWrapper>
          <InputWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{t('memberDetail.modifyModal.changeGender')}</Text>
            <GenderBoxWrapper>
              <GenderBox isClicked={changeGender === 'male'} onClick={() => setChangeGender('male')}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={ changeGender === 'male' ? '#FFFFFF' : theme.text}>{t('memberDetail.male')}</Text>
              </GenderBox>
              <GenderBox isClicked={changeGender === 'female'} onClick={() => setChangeGender('female')}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={ changeGender === 'female' ? '#FFFFFF' : theme.text}>{t('memberDetail.female')}</Text>
              </GenderBox>
            </GenderBoxWrapper>
          </InputWrapper>
          </InfoBox>
        </TotalWrapper>
        <ButtonWrapper>
          <ExitButton onClick={onClickClose}>{t('memberDetail.cancel')}</ExitButton>
          <SaveButton onClick={onClickSaveButton}>{t('memberDetail.save')}</SaveButton>
        </ButtonWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}


const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 576px;
  height: 478px;

  border-radius: 10px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 93.05%;

  gap: 8px;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 30px;

  width: 93.05%;

  gap: 8px;
`;

const ProfileBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 298px;
  height: 298px;

  &:hover {
    cursor: pointer;
  }
`;

const ProfileBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};
`;

const Profile = styled.img`
  width: 100%;
  height: 100%;
  
  border-radius: 10px;
  
  overflow: hidden;

  object-fit: contain;
`;

const PlusBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;  
`;

const Stick = styled.div`
  position: absolute;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 20px;
  background-color: ${props => props.theme.subText};
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 230px;

  gap: 16px;
`;

const GenderBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const GenderBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: calc(47.61% - 2px);
  height: 30px;

  border-radius: 5px;
  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 12px;
`;

const DateInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 8px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 30px;

  width: 93.05%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 38px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subText};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;